import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { Link, useNavigate } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";
import AdminServices from "../../services/AdminServices";
import { notifyError, notifySuccess } from "../../utils/toast";

const ChangePass = () => {
  const [currentPassword, setCurrentPassword] = useState("");

  const [password, setPassword] = useState("");
  const [passwordConfirm, setPasswordConfirm] = useState("");

  const [errorMessage, setErrorMessage] = useState(null);

  const adminInfo = JSON.parse(secureLocalStorage.getItem("adminInfo"));

  const [Loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const AdminLogin = (e) => {
    e.preventDefault();
    setLoading(true);
    if (password !== passwordConfirm) {
      setErrorMessage("Passwords Does not Match");
      setLoading(false);
      notifyError("New Password and Confirm Password must be same");
    } else {
      const TimeOut = 0.5;

      AdminServices.ChangeAdminPassword({
        email: adminInfo.email,
        password: currentPassword,
        newPassword: password,
      })
        .then((res) => {
          if (res) {
            setLoading(false);
            notifySuccess("Password Changed Success!");
            secureLocalStorage.setItem("adminInfo", JSON.stringify(res), {
              expires: TimeOut,
            });
            secureLocalStorage.clear();
            navigate("/");
          }
        })
        .catch((err) => {
          notifyError(err ? err.response.data.message : err.message);
          setLoading(false);
        });
    }
  };

  return (
    <>
      <Helmet>
        <title>Login | Embrace Pakistan</title>
        <body className="authentication-bg" />
      </Helmet>
      <div className="account-pages pt-sm-5">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="text-center">
                <Link to="index.html" className="mb-5 d-block auth-logo">
                  <img
                    src="/assets/images/logo-dark.png"
                    alt=""
                    height={80}
                    className="logo logo-dark"
                  />
                  <img
                    src="/assets/images/logo-light.png"
                    alt=""
                    height={80}
                    className="logo logo-light"
                  />
                </Link>
              </div>
            </div>
          </div>
          <div className="row align-items-center justify-content-center">
            <div className="col-md-8 col-lg-6 col-xl-5">
              <div className="card">
                <div className="card-body p-4">
                  <div className="text-center mt-2">
                    <h5 className="text-primary">Welcome Back !</h5>
                    <p className="text-muted">
                      Sign in to continue to Agahi easy loan portal.
                    </p>
                  </div>
                  <div className="p-2 mt-4">
                    <form onSubmit={(e) => AdminLogin(e)}>
                      <div className="mb-3">
                        <label className="form-label" htmlFor="userpassword">
                          Current Password
                        </label>
                        <input
                          type="password"
                          className="form-control"
                          id="userpassword"
                          placeholder="Enter password"
                          required
                          onChange={(e) => setCurrentPassword(e.target.value)}
                        />
                      </div>
                      <div className="mb-3">
                        <label className="form-label" htmlFor="userpassword">
                          New Password
                        </label>
                        <input
                          type="password"
                          className="form-control"
                          id="userpassword"
                          placeholder="Enter password"
                          required
                          onChange={(e) => setPassword(e.target.value)}
                        />
                      </div>
                      <div className="mb-3">
                        <label className="form-label" htmlFor="userpassword">
                          Confirm Password
                        </label>
                        <input
                          type="password"
                          className="form-control"
                          id="userpassword"
                          placeholder="Enter password"
                          required
                          onChange={(e) => setPasswordConfirm(e.target.value)}
                        />
                      </div>
                      <div className="form-check">
                        {/*  <input
                          type="checkbox"
                          className="form-check-input"
                          id="auth-remember-check"
                        />
                        <label
                          className="form-check-label"
                          htmlFor="auth-remember-check"
                        >
                          Remember me
                        </label> */}
                      </div>
                      <div className="mt-3 text-end">
                        {Loading ? (
                          <>
                            <div
                              className="spinner-border text-primary m-1"
                              role="status"
                            >
                              <span className="sr-only">Loading...</span>
                            </div>
                          </>
                        ) : (
                          <button
                            className="btn btn-primary w-sm waves-effect waves-light"
                            type="submit"
                          >
                            Change Password
                          </button>
                        )}
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              <div className="mt-5 text-center">
                <p>
                  © Embrace Pakistan. Crafted with&nbsp;
                  <i className="mdi mdi-heart text-danger" /> by&nbsp;
                  <a href="https://websouls.com">Websouls</a>
                </p>
              </div>
            </div>
          </div>
          {/* end row */}
        </div>
        {/* end container */}
      </div>
    </>
  );
};

export default ChangePass;
